// Module
var code = "<div class=\"bs-loader not-blur\" v-show=show> <div class=loader-content> <div class=loader-circle> <img src=/assets/img/loading-buson.gif alt=\"Carregando o Buson Suíte\" title=\"Carregando o Buson Suíte\"> </div> </div> </div> ";
// Exports
module.exports = code;